<template>
  <v-app>
    <GlobalHeader />
      <router-view />
    <GlobalFooter />
  </v-app>
</template>

<script>
import GlobalHeader from './components/organisms/GlobalHeader.vue' // ヘッダー
import GlobalFooter from './components/organisms/GlobalFooter.vue' // フッター

export default {
  components: {
    GlobalHeader,
    GlobalFooter,
  },
};
</script>
